<template>
  <section>
    <v-dialog
      v-model="isShow"
      width="400px">
      <div class="dialog-container">
        <div class="dialog-header">
          <span>{{title}}</span>
        </div>

        <el-form
          ref="form"
          :model="formData"
          :rules="rules">
          <!-- mobile -->
          <template v-if="type == 1">
            <div class="dialog-body">

              <template v-if="step == 1">
                <div class="tips">When you click “Continue,” a verification code will be sent to the customer. </div>
                <div class="info">
                  <span class="title">New Mobile Number</span>
                  <el-form-item
                    ref="phone"
                    prop="phone"
                    :rules="rules.mobile_no">
                    <v-input
                      v-model="formData.phone"
                      maxlength="8"
                      type="number"/>
                  </el-form-item>
                </div>
              </template>

              <template v-if="step == 2">
                <div class="tips">Please enter the verification code sent to “{{formData.phone}}”</div>
                <div class="info">
                  <span class="title">Verification Code</span>
                  <el-form-item
                    ref="code"
                    prop="code">
                    <v-input
                      v-model="formData.code"
                      type="number"/>
                  </el-form-item>
                </div>
              </template>

              <template v-if="step == 3">
                <div class="tips">This account’s mobile number is now “{{formData.phone}}”</div>
              </template>
            </div>
            <div class="dialog-footer">

              <template v-if="step == 1">
                <v-button
                  class="cancel"
                  @click="handleCancel">Cancel</v-button>
                <v-button
                  class="success"
                  @click="mobileHandleNext">Continue</v-button>
              </template>

              <template v-if="step == 2">
                <v-button
                  class="cancel"
                  @click="handleCancel">Cancel</v-button>
                <v-button
                  class="success"
                  @click="verifyMobile">Verify</v-button>
              </template>

              <template v-if="step == 3">
                <v-button
                  class="success done"
                  @click="handleDone">Done</v-button>
              </template>
            </div>
          </template>

          <!-- email -->
          <template v-else>
            <div class="dialog-body">

              <template v-if="step == 1">
                <div class="info">
                  <span class="title">New email</span>
                  <el-form-item
                    ref="email"
                    prop="email" >
                    <v-input v-model="formData.email" />
                  </el-form-item>
                </div>
              </template>

              <template v-if="step == 2">
                <div class="tips">An email will be sent to “{{formData.email}}” with a link to verify with HoldCover. Continue?</div>
              </template>

              <template v-if="step == 3">
                <div class="tips">An email has been sent to “{{formData.email}}”</div>
              </template>

            </div>
            <div class="dialog-footer">

              <template v-if="step == 1">
                <v-button
                  class="cancel"
                  @click="handleCancel">Cancel</v-button>
                <v-button
                  class="success"
                  @click="emailHandleContinue">Continue</v-button>
              </template>

              <template v-if="step == 2">
                <v-button
                  class="cancel"
                  @click="handleCancel">Abandon Email Edit</v-button>
                <v-button
                  class="success"
                  @click="emailSendVerify">Send</v-button>
              </template>

              <template v-if="step == 3">
                <v-button
                  class="success done"
                  @click="handleDone">Done</v-button>
              </template>

            </div>
          </template>
        </el-form>
      </div>
    </v-dialog>
  </section>
</template>

<script>
import MixinRules from '@/mixins/rules'
import {sendCode, verifyCode} from '@/api/account'
import {checkEmail} from '@/utils/validate'
export default {
  name: 'email-dialog',
  mixins: [MixinRules],
  props:{
    type: {
      type: [Number,String],
      default: 1  //1: mobile 2: email
    },
    setStep: {
      type: [Number,String],
      default: 1
    }
  },
  data(){
    return{
      isShow: false,
      step: 1,
      formData:{
        phone: '',
        email: '',
        code: ''
      },
      code_token: '',
      extraRules: {
        code: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        email: [
          { required: true, message: this.$t('placeholder.input'),  trigger: ['change', 'blur'] },
          { validator: checkEmail, trigger: ['change', 'blur'] },
        ]
      },
    }
  },

  computed:{
    title(){
      return this.type == 1? 'Edit Mobile Number' : 'Edit Email'
    },
    customerId(){
      return this.$route.query.customer_id||''
    }
  },

  watch:{
    setStep:{
      immediate: true,
      handler(val){
        this.step = val
      }
    }
  },

  methods:{
    changeDialog(){
      this.isShow = !this.isShow
      this.step = 1
    },
    handleCancel(){
      this.changeDialog()
      this.$refs['form'].resetFields()
    },

    mobileHandleNext(){
      this.$refs['form'].validate(valid => {
        if(valid){
          this.network().sendCode()

        }
      })
    },

    verifyMobile(){
      this.$refs['form'].validate(valid => {
        if(valid){
          this.network().verifyCode()
        }
      })
    },

    emailHandleContinue(){
      this.$refs['form'].validate(valid => {
        if(valid){
          this.step += 1
        }
      })
    },

    emailSendVerify(){
      this.$refs['form'].validate(valid => {
        if(valid){
          this.$emit('verifyEmail', this.formData.email)
        }
      })
    },
    handleNext(){
      this.$refs['form'].validate(valid => {
        if(valid){
          this.step += 1
        }
      })
    },

    handleDone(){
      this.updateAccount()
      this.changeDialog()
      this.step = 1
    },

    updateAccount(){
      this.$parent.updateAccount()
    },

    network(){
      return {
        sendCode: async() =>  {
          let params = {
            user_id: this.customerId,
            mobile_no: this.formData.phone
          }
          const {data} = await sendCode(params)
          this.code_token = data.code_token
          let {code} = data
          if(code==4006)
            return
          this.step += 1
        },

        verifyCode: async() =>  {
          let params = {
            mobile_no: this.formData.phone,
            code: this.formData.code,
            code_token: this.code_token
          }
          const {data} = await verifyCode(params)
          if(data.code == 1000){
            this.step += 1
          }
        },
      }
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-dialog{
    box-sizing: border-box;
    border-radius: 6px;
  }
  .dialog-container {
    .dialog-header {
      padding: 16px;
      background: #F6F8FA;
      border-bottom: 1px solid #E1E4E8;
      border-radius: 6px 6px 0 0;
      span{
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        display: flex;
        align-items: center;
        color: #1B1F23;
        flex: none;
        order: 0;
        align-self: stretch;
        flex-grow: 0;
        /*margin: 10px 0px;*/
      }
    }
    .dialog-body{
      padding: 20px 15px;
      .tips{
        color: #24292E;
      }
      .info{
        .title{
          font-weight: 600;
          font-size: 14px;
          color: #24292E;
        }
      }
      .tips + .info{
        margin-top: 20px;
      }
    }
    .dialog-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px;
      padding-top: 0;
      .el-button{
        background: #FAFBFC;
        border: 1px solid rgba(27, 31, 35, 0.15);
        box-sizing: border-box;
        box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.04);
        border-radius: 6px;
        font-weight: 600;
        font-family: 'Inter';
      }
      .success{
        background: #2EA44F;
        color: #FFFFFF;
      }
      .cancel{
        color: #24292E;
      }
      .done{
        width: 100%;
      }
    }
  }
</style>
